import { render, staticRenderFns } from "./kpxx.vue?vue&type=template&id=302806b4&"
import script from "./kpxx.vue?vue&type=script&lang=js&"
export * from "./kpxx.vue?vue&type=script&lang=js&"
import style0 from "./kpxx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports